export const CLIENT_CHANGE_LOADING = "CLIENT_CHANGE_LOADING";
export const CLIENT_CHANGE_SUCCESS = "CLIENT_CHANGE_SUCCESS";
export const CLIENT_CHANGE_FAILED = "CLIENT_CHANGE_FAILED";